import React from 'react';
import Persona from '../../components/persona/Persona';
import Layout from '../../components/layout/Layout';

const PersonaPage = () => {
    return ( <Layout children={<Persona />} /> )
}

export default PersonaPage